export const OPTION_MODE = {
	MERGE: "merge",
	MANUAL_ONLY: "manual-only",
};
